import { ErrorSuccessStatusIndicator } from '@/components/modules/AgentDetail/AgentDetails/components/ErrorSuccessStatusIndicator';
import { Text } from '@/components/shared/components/Text';

export const DEFAULT_ENABLED_DISABLED_VALUES = [
  {
    value: true,
    display: (
      <>
        <Text tId={'ENABLED'} />
        <ErrorSuccessStatusIndicator value={true} />
      </>
    ),
  },
  {
    value: false,
    display: (
      <>
        <Text tId={'DISABLED'} />
        <ErrorSuccessStatusIndicator value={false} />
      </>
    ),
  },
];
